import React from 'react';
import './confidence-section.css';

const ConfidenceSection = ({ confidence }) => {
  const percentage = Math.round(confidence * 100);
  return (
    <div className="confidence-section">
      <h4>Confidence Score</h4>
      <div className="confidence-bar-container">
        <div className="confidence-bar" style={{ width: `${percentage}%` }} />
      </div>
      <span className="confidence-percentage">{percentage}%</span>
    </div>
  );
};

export default ConfidenceSection;
